/* Release 6.11 (spec 31, Part A, 2.2 and 2.5). O teste da segunda in four
   chapters. One IntersectionObserver marks the chapter that crosses the middle
   of the screen as active (aria-current="step") and crossfades the frame to
   its photo; CSS does the fade, and nothing fades under reduced motion. No
   scroll handlers, no animation library, no scroll snapping. Without this
   script the chapters stay plain cards with their own photos.
   Events (allow list in av-analytics-v53.js), each once per session:
   au_story_view, au_story_chapter (story_chapter), au_story_complete and
   au_story_cta (story_cta: granola or teste). The controller starts and stops with
   the theme editor's section load and unload. */
(() => {
  const controllers = new WeakMap();
  const track = (name, payload) => { try { window.AVAnalytics?.custom?.(name, payload); } catch (_) { /* analytics are optional */ } };
  const once = (key, fire) => {
    try {
      if (sessionStorage.getItem(key)) return;
      sessionStorage.setItem(key, '1');
    } catch (_) { /* private mode: fire anyway */ }
    fire();
  };

  const start = (root) => {
    if (!root || controllers.has(root) || !('IntersectionObserver' in window)) return;
    const chapters = [...root.querySelectorAll('[data-au-r611-chapter]')];
    const shots = [...root.querySelectorAll('.au-r611-story__shot')];
    const count = root.querySelector('[data-au-r611-count]');
    if (chapters.length !== 4) return;
    root.classList.add('is-js');

    let active = -1;
    const setActive = (i, silent) => {
      if (i !== active) {
        active = i;
        chapters.forEach((c, n) => { if (n === i) c.setAttribute('aria-current', 'step'); else c.removeAttribute('aria-current'); });
        shots.forEach((s, n) => s.classList.toggle('is-active', n === i));
        if (count) count.textContent = `0${i + 1}`;
      }
      if (silent) return;
      once(`au_story_chapter_${i + 1}`, () => track('au_story_chapter', { story_chapter: i + 1 }));
      if (i === 3) once('au_story_complete', () => track('au_story_complete', {}));
    };

    // A chapter is active while it crosses the middle band of the screen.
    const chapterObserver = new IntersectionObserver((entries) => {
      const hit = entries.filter((e) => e.isIntersecting).map((e) => chapters.indexOf(e.target));
      if (hit.length) setActive(Math.max(...hit));
    }, { rootMargin: '-45% 0px -45% 0px' });
    chapters.forEach((c) => chapterObserver.observe(c));

    const viewObserver = new IntersectionObserver((entries) => {
      if (entries.some((e) => e.isIntersecting)) {
        once('au_story_view', () => track('au_story_view', {}));
        viewObserver.disconnect();
      }
    }, { threshold: 0.2 });
    viewObserver.observe(root);

    const onClick = (event) => {
      const cta = event.target.closest('[data-au-r611-cta]');
      if (cta) once(`au_story_cta_${cta.dataset.auR611Cta}`, () => track('au_story_cta', { story_cta: cta.dataset.auR611Cta }));
    };
    root.addEventListener('click', onClick);

    setActive(0, true);
    controllers.set(root, () => {
      chapterObserver.disconnect();
      viewObserver.disconnect();
      root.removeEventListener('click', onClick);
      root.classList.remove('is-js');
    });
  };

  const stop = (root) => {
    const off = root && controllers.get(root);
    if (off) { off(); controllers.delete(root); }
  };

  const init = (scope) => scope.querySelectorAll('[data-au-r611-story]').forEach(start);
  init(document);
  document.addEventListener('shopify:section:load', (event) => init(event.target));
  document.addEventListener('shopify:section:unload', (event) => event.target.querySelectorAll('[data-au-r611-story]').forEach(stop));
  document.addEventListener('shopify:block:select', (event) => {
    const chapter = event.target.closest?.('[data-au-r611-chapter]');
    const root = chapter?.closest('[data-au-r611-story]');
    if (root) start(root);
  });
})();
